export const GET_FORM_B_ACTIVITY_REQUEST = "GET_FORM_B_ACTIVITY_REQUEST";
export const GET_FORM_B_ACTIVITY_SUCCESS = "GET_FORM_B_ACTIVITY_SUCCESS";
export const GET_FORM_B_ACTIVITY_FAILURE = "GET_FORM_B_ACTIVITY_FAILURE";
